import type { ApiError, ApiErrorType } from '@/types/common/api.type';

const DEFAULT_ERROR_MESSAGE =
    'Đã xảy ra lỗi không xác định. Vui lòng thử lại sau hoặc liên hệ bộ phận kỹ thuật.';

export function createApiError(params: {
    code: string | number;
    message?: string;
    type: ApiErrorType;
    status?: number;
    raw?: unknown;
}): ApiError {
    return {
        code: params.code,
        message: params.message ?? DEFAULT_ERROR_MESSAGE,
        status: params.status,
        type: params.type,
        raw: sanitizeRawError(params.raw),
        timestamp: new Date().toISOString(),
    };
}

function sanitizeRawError(raw: unknown) {
    if (!raw) return undefined;

    if (typeof raw === 'string') return raw;

    if (typeof raw === 'object') {
        return {
            name: (raw as any).name,
            message: (raw as any).message,
        };
    }

    return undefined;
}
